<script>
export default {
}
</script>

<template>
  <div class="hs-van-switch-wrapper" :style="{fontSize: $attrs.size + 'px'}">
    <div class="node" :style="{transform: $attrs.value ? 'translateX(0.72em)' : ''}">
      <span><slot name="node"></slot></span>
    </div>
    <van-switch class="hs-van-switch" v-bind="$attrs" v-on="$listeners">
      <!-- 插槽内容也可以传递 -->
      <slot></slot>
      <template v-for="(_, slot) in $slots" v-slot:[slot]>
        <slot :name="slot"></slot>
      </template>
    </van-switch>
  </div>
</template>

<style scoped lang="stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-van-switch-wrapper{
  width: auto;
  height: auto;
  flex-shrink: 0;
  position: relative;
  >.node{
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0.08em;
    left: 0.06em;
    width: 0.84em;
    height: 0.84em;
    z-index: 1;
    transition: transform .3s cubic-bezier(.3,1.05,.4,1.05);
    pointer-events: none;
    >span{
      font-size: 12px;
      line-height: 18px;
      font-weight: 500;
      color: $color_theme_300;
    }
  }
}
.hs-van-switch{
  width: 1.72em;
  border: none;
  flex-shrink: 0;
  :deep(.van-switch__node){
    width: 0.84em;
    height: 0.84em;
    top: 0.08em;
    left: 0.06em;
  }
  &.van-switch--on :deep(.van-switch__node){
    transform: translateX(0.72em)
  }
}
</style>
